import { useState, useEffect } from 'react';

export const useValidationErrors = (initialErrors: string[] = []) => {
  const [validationErrors, setValidationErrors] = useState<string[]>(initialErrors);

  const addError = (error: string) => {
    setValidationErrors(prev => [...prev, error]);
  };

  const clearErrors = () => {
    setValidationErrors([]);
  };

  const updateErrors = (errors: string[]) => {
    setValidationErrors(errors);
  };

  // Update errors when initial errors change (like from population analysis)
  useEffect(() => {
    setValidationErrors(initialErrors);
  }, [initialErrors]);

  return {
    validationErrors,
    addError,
    clearErrors,
    updateErrors
  };
};